import React from "react";
import LabelLine from "./labelLine";
import { getXOffset, getYOffset, getAverage } from "./math";

const Label = props => {
  const {
    datum,
    innerRadius,
    radius,
    slice: { startAngle, endAngle },
    nameKey,
    cx,
    cy,
  } = props;



  // calculation
  const middleRadius = getAverage([innerRadius, radius]);
  const midAngle = getAverage([endAngle, startAngle]);
  const labelOffset = radius + middleRadius / 2 + 2;
  const x = cx + getXOffset(labelOffset, midAngle);
  const y = cy + getYOffset(labelOffset, midAngle);
  const textAnchor = cx < x ? "start" : "end";

  const name = datum[nameKey];

  return (
    <g>
        { /* <rect x={x} y={y - 15} width="101" height="35" fill="#FBFBFB" stroke-width="1" stroke="#c4c4c4" /> */}
        <text style={{ cursor: 'pointer', userSelect: 'none', fontFamily: 'Roboto', letterSpacing: '-0.5px', fontSize: '16px' }} id={props.datum.id} x={x} y={y+5} textAnchor={textAnchor} fill='#4B4B4B'>
          {/* `${name} - ${Math.round(value)}%` */}
          {name}
        </text>
        <LabelLine
          cx={cx}
          cy={cy}
          middleRadius={middleRadius}
          radius={radius}
          midAngle={midAngle}
        />
      </g>
  )
}

export default Label;
